export const redditData = [
  {
    name: "Texas church shooter was a militant atheist",
    number_of_posts: 121,
    percentage_fake: 79.9,
    spreaders: "COM 1",
    victims: "COM 4",
    ideology: "Progressive Left",
  },
  {
    name: "80% of black men in Atlanta are Homosexuals",
    number_of_posts: 194,
    percentage_fake: 76.3,
    spreaders: "COM 3",
    victims: "COM 5",
    ideology: "Conservative",
  },
  {
    name: "Pope Calls for World Wide Gun Confiscation Except for the UN",
    number_of_posts: 358,
    percentage_fake: 63.3,
    spreaders: "COM 4",
    victims: "COM 1",
    ideology: "Progressive Left",
  },
  {
    name: "Miley Cyrus: 'Donald Trump Is a F--king Nightmare'",
    number_of_posts: 354,
    percentage_fake: 57.3,
    spreaders: "COM 1",
    victims: "COM 5",
    ideology: "Progressive Right",
  },
  {
    name: "Trump Removing Marines From the Navy",
    number_of_posts: 281,
    percentage_fake: 56.2,
    spreaders: "COM 8",
    victims: "COM 6",
    ideology: "Conservative",
  },
  {
    name: "Mueller Will Be Forced To Resign Over Pelosi Affair",
    number_of_posts: 253,
    percentage_fake: 43.56,
    spreaders: "COM 11",
    victims: "COM 6",
    ideology: "Conservative",
  },
  {
    name: "BREAKING: Supreme Court Issues Its First Bench Warrant Ever",
    number_of_posts: 452,
    percentage_fake: 37.3,
    spreaders: "COM 14",
    victims: "COM 3",
    ideology: "Progressive Left",
  },
  {
    name: "Clinton Foundation Largest Unprosecuted Charity Fraud in History-Charles Ortel",
    number_of_posts: 326,
    percentage_fake: 36.23,
    spreaders: "COM 16",
    victims: "COM 7",
    ideology: "Progressive Right",
  },
  {
    name: "NASA Has Just Confirmed Earth Has A New Moon",
    number_of_posts: 183,
    percentage_fake: 34.3,
    spreaders: "COM 18",
    victims: "COM 8",
    ideology: "Progressive Left",
  },
  // {
  //   name: "GabrieleNeher",
  //   number_of_posts: 700,
  //   percentage_fake: 2,
  //   spreaders: ".COM 21",
  //   victims: "COM 3",
  //   ideology: "Progressive Left",
  // },
  // {
  //   name: "UF requests to cancel Rivalry game against FSU",
  //   number_of_posts: 1000,
  //   percentage_fake: 10,
  //   spreaders: "COM8",
  //   victims: "COM 6",
  //   ideology: "Progressive Left",
  // },
  // {
  //   name: "BREAKING: US comedian Kevin Hart in critical condition after gory car crash",
  //   number_of_posts: 800,
  //   percentage_fake: 5,
  //   spreaders: "COM 9",
  //   victims: "COM 3",
  //   ideology: "Conservative",
  // },
  // {
  //   name: "Manager killed 10 employees at checkers on 183st and 27ave",
  //   number_of_posts: 450,
  //   percentage_fake: 8,
  //   spreaders: "COM 12",
  //   victims: "COM 9",
  //   ideology: "Conservative",
  // },
  // {
  //   name: "Ohio student suspended for staying in class during National Walkout Day",
  //   number_of_posts: 550,
  //   percentage_fake: 12,
  //   spreaders: "COM 14",
  //   victims: "COM 11",
  //   ideology: "Progressive Left",
  // },
  // {
  //   name: "Jason Aldean Gig Canceled After He Sells Out To Liberals On SNL",
  //   number_of_posts: 300,
  //   percentage_fake: 6,
  //   spreaders: "COM 20",
  //   victims: "COM 11",
  //   ideology: "Conservative",
  // },
];
